import React from 'react';
import { CircleNotch } from '@phosphor-icons/react';
import { Progress } from '../ui/progress';

/**
 * Live parse-progress card for the import wizard — shown while a PDF/Word
 * roster is being read server-side (structured tables → AI text → vision
 * OCR ladder). Data comes from the authenticated, owner-bound
 * `/import/parse-status/{job_id}` poll.
 */
const ImportProgress = ({ progress }) => {
  if (!progress) return null;
  return (
    <div
      className="bg-indigo-50 border border-indigo-200 rounded-lg p-4 space-y-2"
      data-testid="import-parse-progress"
    >
      <div className="flex items-center gap-2">
        <CircleNotch size={16} className="animate-spin text-indigo-600" />
        <p className="text-sm font-medium text-indigo-900" data-testid="import-parse-progress-label">
          {progress.label}
        </p>
        <span className="ml-auto text-xs font-semibold text-indigo-700" data-testid="import-parse-progress-percent">
          {progress.percent}%
        </span>
      </div>
      <Progress value={progress.percent} className="h-2" data-testid="import-parse-progress-bar" />
      <p className="text-[11px] text-indigo-500">
        Large scanned rosters can take 1–3 minutes. You can switch tabs — progress
        resumes automatically, and it survives a page refresh.
      </p>
    </div>
  );
};

export default ImportProgress;
